// Accept only image sources that the browser can load without treating user
// content as an executable or protocol-relative navigation target.
export function isAllowedAttachmentURL(value: string): boolean {
  const url = value.trim();
  if (!url) return false;
  return /^https?:\/\//i.test(url) || /^\/(?!\/)/.test(url);
}
